// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DevType } from "./dev-type";
import {
  DiscreteToLn2Entry,
  DiscreteToLn2EntryT,
  verifyDiscreteToLn2Entry,
} from "./discrete-to-ln2-entry";

export class Mapping implements flatbuffers.IUnpackableObject<MappingT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Mapping {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMapping(bb: flatbuffers.ByteBuffer, obj?: Mapping): Mapping {
    return (obj || new Mapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMapping(bb: flatbuffers.ByteBuffer, obj?: Mapping): Mapping {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Mapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  discreteToMessage(index: number, obj?: DiscreteToLn2Entry): DiscreteToLn2Entry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new DiscreteToLn2Entry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  discreteToMessageLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  devType(): DevType {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DevType.LV16Input;
  }

  static startMapping(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addDiscreteToMessage(
    builder: flatbuffers.Builder,
    discreteToMessageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, discreteToMessageOffset, 0);
  }

  static createDiscreteToMessageVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDiscreteToMessageVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDevType(builder: flatbuffers.Builder, devType: DevType) {
    builder.addFieldInt8(1, devType, DevType.LV16Input);
  }

  static endMapping(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // discrete_to_message
    return offset;
  }

  static finishMappingBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedMappingBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, undefined, true);
  }

  static createMapping(
    builder: flatbuffers.Builder,
    discreteToMessageOffset: flatbuffers.Offset,
    devType: DevType,
  ): flatbuffers.Offset {
    Mapping.startMapping(builder);
    Mapping.addDiscreteToMessage(builder, discreteToMessageOffset);
    Mapping.addDevType(builder, devType);
    return Mapping.endMapping(builder);
  }

  unpack(): MappingT {
    return new MappingT(
      this.bb!.createObjList<DiscreteToLn2Entry, DiscreteToLn2EntryT>(
        this.discreteToMessage.bind(this),
        this.discreteToMessageLength(),
      ),
      this.devType(),
    );
  }

  unpackTo(_o: MappingT): void {
    _o.discreteToMessage = this.bb!.createObjList<DiscreteToLn2Entry, DiscreteToLn2EntryT>(
      this.discreteToMessage.bind(this),
      this.discreteToMessageLength(),
    );
    _o.devType = this.devType();
  }

  unpackFields(...fields: string[]): MappingT {
    const t = new MappingT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("discrete_to_message")) {
      t.discreteToMessage = this.bb!.createObjList<DiscreteToLn2Entry, DiscreteToLn2EntryT>(
        this.discreteToMessage.bind(this),
        this.discreteToMessageLength(),
      );
    }
    if (fieldSet.has("dev_type")) {
      t.devType = this.devType();
    }
    return t;
  }
}

export class MappingT implements flatbuffers.IGeneratedObject {
  constructor(
    public discreteToMessage: DiscreteToLn2EntryT[] = [],
    public devType: DevType = DevType.LV16Input,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.discreteToMessage === null || this.discreteToMessage === undefined) {
      throw new Error('Required field "discrete_to_message" is not set');
    }
    const discreteToMessage = Mapping.createDiscreteToMessageVector(
      builder,
      builder.createObjectOffsetList(this.discreteToMessage),
    );

    return Mapping.createMapping(builder, discreteToMessage, this.devType);
  }

  clone(): MappingT {
    const obj = new MappingT();
    obj.discreteToMessage = this.discreteToMessage.map((e) => e.clone());
    obj.devType = this.devType;
    return obj;
  }

  equals(other: MappingT): boolean {
    if (this.discreteToMessage.length !== other.discreteToMessage.length) return false;
    for (let i = 0; i < this.discreteToMessage.length; i++) {
      const a = this.discreteToMessage[i];
      const b = other.discreteToMessage[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.devType !== other.devType) return false;
    return true;
  }
}

export function verifyMapping(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDiscreteToLn2Entry);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "discrete_to_message");
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsMapping(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyMapping(verifier, tablePos);
}
